import { render, staticRenderFns } from "./EditCompanyDialog.vue?vue&type=template&id=225d9c6c&scoped=true&"
import script from "./EditCompanyDialog.vue?vue&type=script&lang=js&"
export * from "./EditCompanyDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditCompanyDialog.vue?vue&type=style&index=0&id=225d9c6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225d9c6c",
  null
  
)

export default component.exports